import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconClockSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconClockSquare"><Path d="M13 9V11.5855L14.9142 13.5002L13.4998 14.9142L11 12.4137V9H13Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M21 3H3V21H21V3ZM12 6.5C8.96243 6.5 6.5 8.96243 6.5 12C6.5 15.0376 8.96243 17.5 12 17.5C15.0376 17.5 17.5 15.0376 17.5 12C17.5 8.96243 15.0376 6.5 12 6.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconClockSquare;
